'use strict';


var clientSideValidation = require('base/components/clientSideValidation');

function invalid() {
    $('form input, form select, form textarea').on('invalid', function (e) {
        const shipmentTypeValue = $('#shipmentType').val();
        e.preventDefault();
        if (shipmentTypeValue === 'storePickUp' && !$(this).hasClass('shippingPhoneNumber')) {
            return;
        }
        this.setCustomValidity('');
        if (!this.validity.valid) {
            var validationMessage = 'Por favor, ingrese un valor válido.';
            $(this).addClass('is-invalid');
            if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                validationMessage = $(this).data('pattern-mismatch');
            }
            if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                && $(this).data('range-error')) {
                validationMessage = $(this).data('range-error');
            }
            if ((this.validity.tooLong || this.validity.tooShort)
                && $(this).data('range-error')) {
                validationMessage = $(this).data('range-error');
            }
            if (this.validity.valueMissing && $(this).data('missing-error')) {
                validationMessage = $(this).data('missing-error');
            }
            if (this.validity.typeMismatch && $(this).data('type-mismatch')) {
                validationMessage = $(this).data('type-mismatch');
            }
            $(this).parents('.form-group').find('.invalid-feedback')
                .text(validationMessage);
        }
    });
}

// Replace any other characters but numbers in the input element
function onlyNumbers() {
    $(this).val($(this).val().replace(/\D/g,''));
}

// Replace numbers in the string
function onlyCharacters() {
    $(this).val($(this).val().replace(/[0-9]/g,''));
}

$(document).ready(function (e) {
   $('.closedEyes, .openEyes').click(function () {
      togglePassword.call(this);
   });
});

function togglePassword() {
  let isClosedEyes = $(this).hasClass('closedEyes');
  if (isClosedEyes) {
    $(this).removeClass('closedEyes');
    $(this).addClass('openEyes');
    $(this).parent().children('.form-control').attr('type', 'text');
  }
  else {
    $(this).addClass('closedEyes');
    $(this).removeClass('openEyes');
    $(this).parent().children('.form-control').attr('type', 'password');
  }
}

clientSideValidation.invalid = invalid;
clientSideValidation.functions.onlyNumbers = onlyNumbers;
clientSideValidation.functions.onlyCharacters = onlyCharacters;
clientSideValidation.togglePassword = togglePassword;

module.exports= clientSideValidation;
